import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  Spinner,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CarruselFotos from "./CarruselFotos";
import {
  guardarBorradorPedido,
  cargarBorradorPedido,
  limpiarBorradorPedido,
} from "../../../utils/pedidoBorrador";

const ITEMS_POR_PAGINA = 24;
const SIN_IMAGEN = process.env.PUBLIC_URL + "/sinImagen.png";

function PedidosCreateMarket() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_FOTO_CLOUDINARY = process.env.REACT_APP_URL_FOTO_CLOUDINARY;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;

  const hoy = moment(new Date()).format("YYYY-MM-DD");
  const fechaInicioDefault = moment(new Date()).add(3, "days").format("YYYY-MM-DD");
  const fechaCancelacionDefault = moment(new Date()).add(10, "days").format("YYYY-MM-DD");

  const [cargando, setCargando] = useState(true);

  // Catalogos
  const [articulos, setArticulos] = useState([]);
  const [inventariosDisp, setInventariosDisp] = useState({});
  const [pendRecibirMap, setPendRecibirMap] = useState({}); // idArticulo -> {pendiente_recibir, proximaLlegada}
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [lineas, setLineas] = useState([]);

  // Header
  const [valueCliente, setValueCliente] = useState(null);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedSucursal, setSelectedSucursal] = useState("");
  // const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [paqueteria, setPaqueteria] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [listaPrecios, setListaPrecios] = useState(1);
  const [selectedImpuesto, setSelectedImpuesto] = useState(16);
  const [telefonoCliente, setTelefonoCliente] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");

  // Filtros
  const [search, setSearch] = useState("");
  const [filtroMarca, setFiltroMarca] = useState("");
  const [filtroLinea, setFiltroLinea] = useState("");
  const [orden, setOrden] = useState("codigo");
  const [pagina, setPagina] = useState(1);

  // Carrito
  const [cart, setCart] = useState([]);
  const [cantidadesTemp, setCantidadesTemp] = useState({});
  const [validaBoton, setValidaBoton] = useState(true);

  // Modal detalle de producto
  const [modalDetalle, setModalDetalle] = useState(false);
  const [detalleArt, setDetalleArt] = useState(null);

  // Modal carrito (para móvil/sticky)
  const [modalCarrito, setModalCarrito] = useState(false);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    Promise.all([
      axios.get(`${URL_ARTICULOS}Activos`, { headers }),
      axios.get(`${URL_CLIENTES}GeneralActivos`, { headers }),
      axios.get(URL_COLABORADORES, { headers }),
      axios.get(`${URL_INVENTARIOS}Disponible`, { headers }),
      axios.get(URL_SUCURSALES, { headers }),
      axios.get(URL_LINEAS, { headers }),
      axios.get(URL_MARCAS, { headers }),
      axios.get(`${URL_ARTICULOS_EMBARQUES}PendRecibirAgrupado`, { headers }),
    ])
      .then(([rA, rC, rCol, rI, rS, rL, rM, rPR]) => {
        setArticulos(rA.data || []);
        setClientes(rC.data || []);
        setColaboradores(rCol.data || []);
        const map = {};
        (rI.data || []).forEach((d) => {
          map[d.idArticulo] = Number(d.disponible || 0);
        });
        setInventariosDisp(map);
        const pr = {};
        (rPR.data || []).forEach((d) => {
          pr[d.idArticulo] = {
            pendiente_recibir: Number(d.pendiente_recibir || 0),
            proximaLlegada: d.proximaLlegada || "",
          };
        });
        setPendRecibirMap(pr);
        setSucursales(rS.data || []);
        setLineas(rL.data || []);
        setMarcas(rM.data || []);

        // Hidratar desde borrador si existe
        const b = cargarBorradorPedido();
        if (b) {
          if (b.items && Array.isArray(b.items)) setCart(b.items);
          if (b.clienteId) {
            const c = (rC.data || []).find((x) => x._id === b.clienteId);
            if (c) setValueCliente(c);
          }
          if (b.colaboradorId) setSelectedColaborador(b.colaboradorId);
          if (b.sucursalId) setSelectedSucursal(b.sucursalId);
          // if (b.departamentoId) setDepartamentoCliente(b.departamentoId);
          if (b.fecha) setFecha(b.fecha);
          if (b.paqueteria != null) setPaqueteria(b.paqueteria);
          if (b.observaciones != null) setObservaciones(b.observaciones);
          if (b.listaPrecios != null) setListaPrecios(Number(b.listaPrecios));
          if (b.selectedImpuesto != null) setSelectedImpuesto(Number(b.selectedImpuesto));
        }

        setCargando(false);
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Swal.fire({
          icon: "error",
          title: "Error de carga",
          text: "No se pudo cargar el catálogo. Revisa tu conexión.",
        });
      });
  }, []);

  // Guardar borrador cada vez que cambien los datos relevantes
  useEffect(() => {
    if (cargando) return;
    guardarBorradorPedido({
      items: cart,
      clienteId: valueCliente?._id || "",
      colaboradorId: selectedColaborador,
      sucursalId: selectedSucursal,
      // departamentoId: departamentoCliente,
      fecha,
      paqueteria,
      observaciones,
      listaPrecios,
      selectedImpuesto,
    });
  }, [
    cargando,
    cart,
    valueCliente,
    selectedColaborador,
    selectedSucursal,
    // departamentoCliente,
    fecha,
    paqueteria,
    observaciones,
    listaPrecios,
    selectedImpuesto,
  ]);

  // V12: skip sucursal reset on initial hydration from borrador
  const clienteInicialRef = useRef(true);
  // Auto-llenar al elegir cliente
  useEffect(() => {
    if (!valueCliente) {
      setSelectedColaborador("");
      // setDepartamentoCliente("");
      setTelefonoCliente("");
      setNombreCliente("");
      setSelectedSucursal("");
      return;
    }
    setNombreCliente(valueCliente.nombre_comercial || "");
    setTelefonoCliente(valueCliente.telefono || "");
    if (valueCliente.vendedor?.[0]) {
      const v = valueCliente.vendedor[0];
      setSelectedColaborador(typeof v === "string" ? v : v._id);
    }
    if (valueCliente.listaPrecios) {
      setListaPrecios(Number(valueCliente.listaPrecios));
    }
    // V12: la primera vez (hidratación desde borrador), no reseteamos sucursal
    if (clienteInicialRef.current) {
      clienteInicialRef.current = false;
      return;
    }
    setSelectedSucursal("");
  }, [valueCliente]);

  // Sucursales del cliente seleccionado
  const sucursalesCliente = useMemo(() => {
    if (!valueCliente) return [];
    return (sucursales || []).filter((s) => {
      if (s.is_active !== "Si") return false;
      return (s.clientes || []).some((c) => {
        const cid = typeof c === "string" ? c : c?._id;
        return cid === valueCliente._id;
      });
    });
  }, [sucursales, valueCliente]);

  // Auto-seleccionar la única sucursal si solo hay una
  useEffect(() => {
    if (sucursalesCliente.length === 1 && !selectedSucursal) {
      setSelectedSucursal(sucursalesCliente[0]._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sucursalesCliente]);

  // Helpers
  const precioDeArticulo = (art) => {
    const n = Number(listaPrecios);
    if (n === 2 && art.lista2) return Number(art.lista2);
    if (n === 3 && art.lista3) return Number(art.lista3);
    if (n === 4 && art.lista4) return Number(art.lista4);
    if (art.lista1) return Number(art.lista1);
    return Number(art.venta || 0);
  };

  const fotoUrl = (art) =>
    art.foto === "Si"
      ? `${URL_FOTO_CLOUDINARY}/image/upload/macuroArticulos/${art._id}.jpg`
      : SIN_IMAGEN;

  const moneyUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  // Lista filtrada + ordenada
  const productosFiltrados = useMemo(() => {
    const q = (search || "").toLowerCase().trim();
    const tokens = q ? q.split(/\s+/).filter(Boolean) : [];
    const filtrados = (articulos || []).filter((a) => {
      if (a.is_active !== "Si") return false;
      if (filtroMarca && a.marcas?.[0]?._id !== filtroMarca) return false;
      if (filtroLinea && a.lineas?.[0]?._id !== filtroLinea) return false;
      if (tokens.length > 0) {
        const hay = `${a.codigo || ""} ${a.nombre || ""} ${a.descripcion || ""} ${a.SKU || ""} ${a.marcas?.[0]?.name || ""} ${a.lineas?.[0]?.name || ""}`.toLowerCase();
        return tokens.every((t) => hay.includes(t));
      }
      return true;
    });

    const ordenado = filtrados.slice().sort((a, b) => {
      const dispA = inventariosDisp[a._id] || 0;
      const dispB = inventariosDisp[b._id] || 0;
      if (orden === "nombre") return (a.nombre || "").localeCompare(b.nombre || "");
      if (orden === "precio") return precioDeArticulo(a) - precioDeArticulo(b);
      if (orden === "precio_desc") return precioDeArticulo(b) - precioDeArticulo(a);
      if (orden === "disponible") return dispB - dispA;
      return (a.codigo || "").localeCompare(b.codigo || "");
    });

    return ordenado;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articulos, search, filtroMarca, filtroLinea, orden, inventariosDisp, listaPrecios]);

  useEffect(() => {
    setPagina(1);
  }, [search, filtroMarca, filtroLinea, orden]);

  // Cantidad ya reservada del articulo en el carrito
  const cantidadEnCarrito = (articuloId) =>
    cart
      .filter((c) => c.articulos === articuloId)
      .reduce((acc, c) => acc + Number(c.cantidad || 0), 0);

  const setCantTemp = (id, val) => {
    setCantidadesTemp({ ...cantidadesTemp, [id]: val });
  };

  // V11: setear cantidad va directo al carrito (sin botón Agregar)
  const setCantInline = (art, val) => {
    const cant = Number(val) || 0;
    setCantidadesTemp({ ...cantidadesTemp, [art._id]: val });
    if (cant <= 0) {
      setCart(cart.filter((c) => c.articulos !== art._id));
      return;
    }
    const precio = precioDeArticulo(art);
    const existente = cart.find((c) => c.articulos === art._id);
    if (existente) {
      setCart(
        cart.map((c) =>
          c.articulos === art._id
            ? {
                ...c,
                cantidad: cant,
                cajas: Number(c.piezasPorCaja) > 0 ? cant / Number(c.piezasPorCaja) : 0,
                total: cant * Number(c.precio),
              }
            : c
        )
      );
    } else {
      setCart([
        ...cart,
        {
          id: uuidv4(),
          articulos: art._id,
          articulosNombre: `${art.codigo} ${art.nombre}`,
          codigo: art.codigo,
          piezasPorCaja: Number(art.piezasPorCaja || 0),
          cajas: Number(art.piezasPorCaja) > 0 ? cant / Number(art.piezasPorCaja) : 0,
          cantidad: cant,
          precio,
          total: cant * precio,
          fotoArticulo: art.foto,
        },
      ]);
    }
  };

  const agregarAlCarrito = (art) => {
    const cant = Number(cantidadesTemp[art._id] || 0);
    if (cant <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Captura una cantidad",
        text: "Debes capturar una cantidad mayor a 0",
        timer: 1800,
        showConfirmButton: false,
      });
      return;
    }
    const precio = precioDeArticulo(art);
    const existente = cart.find((c) => c.articulos === art._id);
    let nuevoCart;
    if (existente) {
      nuevoCart = cart.map((c) =>
        c.articulos === art._id
          ? {
              ...c,
              cantidad: Number(c.cantidad) + cant,
              total: (Number(c.cantidad) + cant) * Number(c.precio),
            }
          : c
      );
    } else {
      nuevoCart = [
        ...cart,
        {
          id: uuidv4(),
          articulos: art._id,
          articulosNombre: `${art.codigo} ${art.nombre}`,
          codigo: art.codigo,
          piezasPorCaja: Number(art.piezasPorCaja || 0),
          cajas:
            Number(art.piezasPorCaja) > 0
              ? cant / Number(art.piezasPorCaja)
              : 0,
          cantidad: cant,
          precio,
          total: cant * precio,
          fotoArticulo: art.foto,
        },
      ];
    }
    setCart(nuevoCart);
    setCantTemp(art._id, "");

    Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: "success",
      title: `${art.codigo} agregado (${cant})`,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const cambiarPrecioItem = (id, nuevoPrecio) => {
    const p = parseFloat(nuevoPrecio) || 0;
    setCart(
      cart.map((c) =>
        c.id === id ? { ...c, precio: p, total: Number(c.cantidad) * p } : c
      )
    );
  };

  const cambiarCantidadItem = (id, nuevaCant) => {
    const n = parseFloat(nuevaCant) || 0;
    const item = cart.find((c) => c.id === id);
    setCart(
      cart.map((c) =>
        c.id === id
          ? {
              ...c,
              cantidad: n,
              total: n * Number(c.precio),
              cajas: c.piezasPorCaja > 0 ? n / c.piezasPorCaja : 0,
            }
          : c
      )
    );
  };

  const removeItem = (id) => {
    setCart(cart.filter((c) => c.id !== id));
  };

  // Agregar todos los productos con cantidad > 0 capturada
  const agregarTodos = () => {
    const aAgregar = Object.entries(cantidadesTemp)
      .map(([id, cant]) => ({ id, cant: Number(cant) || 0 }))
      .filter((x) => x.cant > 0);

    if (aAgregar.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin cantidades",
        text: "Captura cantidades en las tarjetas para agregar de un solo golpe",
      });
      return;
    }

    let agregados = 0;
    const nuevasLineas = [];
    for (const { id, cant } of aAgregar) {
      const art = articulos.find((a) => a._id === id);
      if (!art) continue;
      const precio = precioDeArticulo(art);
      nuevasLineas.push({
        id: uuidv4(),
        articulos: art._id,
        articulosNombre: `${art.codigo} ${art.nombre}`,
        codigo: art.codigo,
        piezasPorCaja: Number(art.piezasPorCaja || 0),
        cajas:
          Number(art.piezasPorCaja) > 0 ? cant / Number(art.piezasPorCaja) : 0,
        cantidad: cant,
        precio,
        total: cant * precio,
        fotoArticulo: art.foto,
      });
      agregados += 1;
    }

    // Merge: si ya existe linea para mismo articulo, sumar cantidad
    const merged = [...cart];
    for (const nueva of nuevasLineas) {
      const idx = merged.findIndex((c) => c.articulos === nueva.articulos);
      if (idx >= 0) {
        const sum = Number(merged[idx].cantidad) + Number(nueva.cantidad);
        merged[idx] = {
          ...merged[idx],
          cantidad: sum,
          total: sum * Number(merged[idx].precio),
          cajas:
            merged[idx].piezasPorCaja > 0 ? sum / merged[idx].piezasPorCaja : 0,
        };
      } else {
        merged.push(nueva);
      }
    }
    setCart(merged);
    setCantidadesTemp({});

    Swal.fire({
      toast: true,
      position: "bottom-end",
      icon: "success",
      title: `${agregados} agregados al carrito`,
      showConfirmButton: false,
      timer: 2000,
    });
  };

  const limpiarCarrito = () => {
    if (cart.length === 0) return;
    Swal.fire({
      icon: "warning",
      title: "¿Vaciar carrito?",
      showCancelButton: true,
      confirmButtonText: "Sí, vaciar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (r.isConfirmed) setCart([]);
    });
  };

  const subTotal = useMemo(
    () => cart.reduce((acc, c) => acc + (Number(c.total) || 0), 0),
    [cart]
  );
  const iva = useMemo(
    () => (Number(selectedImpuesto) * subTotal) / 100,
    [subTotal, selectedImpuesto]
  );
  const totalGeneral = useMemo(() => subTotal + iva, [subTotal, iva]);
  const totalCantidad = useMemo(
    () => cart.reduce((acc, c) => acc + (Number(c.cantidad) || 0), 0),
    [cart]
  );

  // Paginación
  const totalPaginas = Math.max(
    1,
    Math.ceil(productosFiltrados.length / ITEMS_POR_PAGINA)
  );
  const productosPagina = useMemo(() => {
    const start = (pagina - 1) * ITEMS_POR_PAGINA;
    return productosFiltrados.slice(start, start + ITEMS_POR_PAGINA);
  }, [productosFiltrados, pagina]);

  const optionsClientes = (clientes || []).map((option) => {
    const junta = `${option.nombre_comercial || ""} ${option.codigo || ""}`;
    const firstLetter = (option.nombre_comercial?.[0] || "0").toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // WhatsApp confirmación
  async function notificarWhatsApp(idPedido) {
    try {
      if (telefonoCliente) {
        await axios.post(
          `${URL_WHATSAPP}SendMsg`,
          {
            number: telefonoCliente,
            message: `Hola ${nombreCliente}, hemos recibido tu pedido (${idPedido}) y comenzaremos a trabajar en él de inmediato. ¡Gracias por tu confianza!`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      }
    } catch (e) {
      console.log("WA no enviado:", e?.message);
    }
  }

  const guardarPedido = async () => {
    if (!valueCliente || !selectedColaborador || !selectedSucursal) {
      Swal.fire({
        icon: "error",
        title: "Faltan datos",
        text: "Cliente, Vendedor y Sucursal son obligatorios",
      });
      return;
    }
    if (cart.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Carrito vacío",
        text: "Debes agregar al menos un artículo",
      });
      return;
    }

    Swal.fire({
      title: "¿Confirmar pedido?",
      html: `<b>${cart.length}</b> productos, <b>${totalCantidad}</b> piezas<br/>Total: <b>${moneyUSD(totalGeneral)}</b>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, guardar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setValidaBoton(false);
      try {
        const data = await axios.post(
          URL_PEDIDOS,
          {
            fecha,
            clientes: valueCliente._id,
            colaboradores: selectedColaborador,
            total_general: Number(totalGeneral).toFixed(2),
            observaciones,
            total_cantidad: totalCantidad,
            paqueteria,
            sucursales: selectedSucursal,
            comisionTDC: 0,
            comisionFlete: 0,
            subTotal: Number(subTotal).toFixed(2),
            iva: Number(iva).toFixed(2),
            impuestos: selectedImpuesto,
            surtido: "No",
            autorizadoApartado: "No",
            autorizadoSurtido: "No",
            editado: "No",
            fechaModificado: fecha,
            creado: user.id,
            fecha_estimada: fecha,
            fecha_entrega: fecha,
            fecha_programada: fechaInicioDefault,
            entregaInsumos: "No",
            fechaInicio: fechaInicioDefault,
            fechaCancelacion: fechaCancelacionDefault,
            piezasEntregadas: 0,
            piezasPendientes: totalCantidad,
            descuento: 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        const pedidoId = data.data._id;
        const idPedido = data.data.idPedido;

        await Promise.all(
          cart.map((c) =>
            axios.post(
              URL_ARTICULOS_PEDIDO,
              {
                pedidos: pedidoId,
                articulos: c.articulos,
                cantidad: Number(c.cantidad),
                cantidadProcesos: 0,
                surtido: 0,
                pendiente_surtir: Number(c.cantidad),
                precio: Number(c.precio).toFixed(2),
                total: Number(c.total).toFixed(2),
                autorizadoSurtido: "No",
                autorizadoApartado: "No",
                clientes: valueCliente._id,
                fecha,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
          )
        );

        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Pedido (Market)",
            detalle: `Cliente ${valueCliente.nombre_comercial} / Total ${totalGeneral}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        notificarWhatsApp(idPedido);

        limpiarBorradorPedido();
        Swal.fire({
          icon: "success",
          title: "Pedido creado",
          html: `Pedido #${idPedido || ""}`,
          timer: 1800,
          showConfirmButton: false,
        });
        setTimeout(() => {
          window.location.href = "/ListadoPedidos";
        }, 1500);
      } catch (error) {
        console.log(error);
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error?.response?.data?.message ||
            "No se pudo crear el pedido. Intenta de nuevo.",
        });
      }
    });
  };

  const abrirDetalle = (art) => {
    setDetalleArt(art);
    setModalDetalle(true);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12" style={{ paddingBottom: 80 }}>
          <h3 align="center">Nuevo Pedido (Market)</h3>

          {/* HEADER */}
          <Form>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Cliente *</Label>
                <Autocomplete
                  size="small"
                  value={valueCliente || null}
                  onChange={(event, sel) => setValueCliente(sel || null)}
                  options={optionsClientes.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta || ((option.codigo || "") + " " + (option.nombre_comercial || ""))}
                  getOptionSelected={(option, val) => option._id === (val && val._id)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.codigo} {option.nombre_comercial}
                    </React.Fragment>
                  )}
                />
              </Col>
              <Col md={2}>
                <Label>Vendedor *</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => setSelectedColaborador(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {colaboradores
                    .filter((c) => c.is_active === "Si")
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.nombre} {c.apellido}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Dir Entrega *</Label>
                <Input
                  type="select"
                  value={selectedSucursal}
                  onChange={(e) => setSelectedSucursal(e.target.value)}
                  disabled={!valueCliente}
                >
                  <option value="">
                    {!valueCliente
                      ? "Elige cliente primero"
                      : sucursalesCliente.length === 0
                      ? "Sin sucursales"
                      : "Selecciona"}
                  </option>
                  {sucursalesCliente
                    .slice()
                    .sort((a, b) =>
                      (a.alias || "").localeCompare(b.alias || "")
                    )
                    .map((s) => (
                      <option key={s._id} value={s._id}>
                        {s.alias}
                        {s.ciudad ? ` — ${s.ciudad}` : ""}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={1}>
                <Label>Lista</Label>
                <Input
                  type="select"
                  value={listaPrecios}
                  onChange={(e) => setListaPrecios(Number(e.target.value))}
                >
                  <option value={1}>Lista 1</option>
                  <option value={2}>Lista 2</option>
                  <option value={3}>Lista 3</option>
                  <option value={4}>Lista 4</option>
                </Input>
              </Col>
              <Col md={1}>
                <Label>IVA %</Label>
                <Input
                  type="select"
                  value={selectedImpuesto}
                  onChange={(e) => setSelectedImpuesto(Number(e.target.value))}
                >
                  <option value={0}>0</option>
                  <option value={16}>16</option>
                </Input>
              </Col>
              <Col md={1}>
                <Label>Carrito</Label>
                <Button
                  color={cart.length > 0 ? "danger" : "secondary"}
                  block
                  size="sm"
                  onClick={() => setModalCarrito(true)}
                  disabled={cart.length === 0}
                >
                  <i className="fas fa-shopping-cart"></i> {cart.length}
                </Button>
              </Col>
            </Row>
            <br />

            {/* FILTROS */}
            <Row>
              <Col md={4}>
                <Label>Buscar</Label>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    placeholder="Código, nombre, descripción, SKU..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  {search && (
                    <InputGroupAddon addonType="append">
                      <Button color="secondary" onClick={() => setSearch("")}>
                        <i className="fas fa-times"></i>
                      </Button>
                    </InputGroupAddon>
                  )}
                </InputGroup>
              </Col>
              <Col md={2}>
                <Label>Marca</Label>
                <Input
                  type="select"
                  value={filtroMarca}
                  onChange={(e) => setFiltroMarca(e.target.value)}
                >
                  <option value="">Todas</option>
                  {marcas
                    .filter((m) => !m.is_active || m.is_active === "Si")
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((m) => (
                      <option key={m._id} value={m._id}>
                        {m.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Categoría</Label>
                <Input
                  type="select"
                  value={filtroLinea}
                  onChange={(e) => setFiltroLinea(e.target.value)}
                >
                  <option value="">Todas</option>
                  {lineas
                    .filter((l) => !l.is_active || l.is_active === "Si")
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((l) => (
                      <option key={l._id} value={l._id}>
                        {l.name}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Ordenar por</Label>
                <Input
                  type="select"
                  value={orden}
                  onChange={(e) => setOrden(e.target.value)}
                >
                  <option value="codigo">Código</option>
                  <option value="nombre">Nombre</option>
                  <option value="precio">Precio asc</option>
                  <option value="precio_desc">Precio desc</option>
                  <option value="disponible">Disponible</option>
                </Input>
              </Col>
            </Row>
            {/* <Row>
              <Col md={12} style={{ marginTop: 6 }}>
                <Button
                  color="warning"
                  size="sm"
                  onClick={agregarTodos}
                  disabled={cargando}
                >
                  <i className="fas fa-cart-arrow-down"></i> Agregar todos los visibles
                </Button>
                <span style={{ marginLeft: 8, fontSize: 12, color: "#666" }}>
                  Captura cantidades en las tarjetas y haz click aquí
                </span>
              </Col>
            </Row> */}
          </Form>
          <br />

          {cargando && (
            <div style={{ textAlign: "center", padding: 30 }}>
              <Spinner style={{ width: 50, height: 50, color: "#232B41" }} />
              <p style={{ marginTop: 10 }}>Cargando catálogo...</p>
            </div>
          )}

          {!cargando && (
            <div style={{ fontSize: 13, color: "#666", marginBottom: 8 }}>
              Mostrando <b>{productosPagina.length}</b> de <b>{productosFiltrados.length}</b> productos
            </div>
          )}

          {/* GRID DE PRODUCTOS */}
          <Row>
            {productosPagina.map((art) => {
              const disp = inventariosDisp[art._id] || 0;
              const precio = precioDeArticulo(art);
              const marcaName = art.marcas?.[0]?.name || "";
              const lineaName = art.lineas?.[0]?.name || "";
              const yaEnCart = cantidadEnCarrito(art._id);
              const pr = pendRecibirMap[art._id] || {};
              const porRecibir = Number(pr.pendiente_recibir || 0);
              const llegada = pr.proximaLlegada || "";
              return (
                <Col md={3} sm={6} xs={12} key={art._id} style={{ marginBottom: 16 }}>
                  <Card style={{ height: "100%" }}>
                    {/* Carrusel: muestra todas las fotos del artículo con
                        flechas y miniaturas. El clic en la imagen sigue
                        abriendo el detalle; flechas y miniaturas no. */}
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => abrirDetalle(art)}
                    >
                      <CarruselFotos
                        articulo={art}
                        sinImagen={SIN_IMAGEN}
                        cloudBase={URL_FOTO_CLOUDINARY}
                        alto={180}
                      />
                    </div>
                    <CardBody style={{ padding: 12 }}>
                      <CardTitle tag="h6" style={{ fontSize: 14, marginBottom: 6 }}>
                        <strong>{art.codigo}</strong>
                        <br />
                        <span style={{ fontSize: 12, fontWeight: "normal" }}>
                          {art.nombre}
                        </span>
                      </CardTitle>
                      <div style={{ fontSize: 11, color: "#666", minHeight: 18 }}>
                        {marcaName ? marcaName : ""}
                        {marcaName && lineaName ? " / " : ""}
                        {lineaName ? lineaName : ""}
                      </div>
                      <div style={{ marginTop: 6 }}>
                        <Badge color={disp > 0 ? "success" : "secondary"}>
                          Disp: {disp}
                          {yaEnCart > 0 ? ` (-${yaEnCart})` : ""}
                        </Badge>{" "}
                        <Badge color="primary">{moneyUSD(precio)}</Badge>
                        {art.piezasPorCaja > 0 && (
                          <Badge color="info" style={{ marginLeft: 4 }}>
                            x{art.piezasPorCaja}
                          </Badge>
                        )}
                      </div>
                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 11,
                          color: porRecibir > 0 ? "#2a7" : "#999",
                          minHeight: 18,
                        }}
                      >
                        {porRecibir > 0 ? (
                          <>
                            <i className="fas fa-truck"></i> Por recibir:{" "}
                            <b>{porRecibir}</b>
                            {llegada ? ` · llega ${llegada}` : ""}
                          </>
                        ) : (
                          <span>Sin pendientes por recibir</span>
                        )}
                      </div>
                      <Row style={{ marginTop: 8 }} noGutters>
                        <Col xs={5}>
                          <Input
                            type="number"
                            min="0"
                            step="1"
                            placeholder="Cant"
                            bsSize="sm"
                            value={cantidadesTemp[art._id] || ""}
                            onChange={(e) =>
                              setCantInline(art, e.target.value)
                            }
                          />
                        </Col>
                        <Col xs={7} style={{ paddingLeft: 4, textAlign: "center", paddingTop: 4 }}>
                          {cart.find((c) => c.articulos === art._id) ? (
                            <span style={{ color: "#28a745", fontWeight: "bold", fontSize: 12 }}>
                              <i className="fas fa-check-circle"></i> En carrito
                            </span>
                          ) : (
                            <span style={{ color: "#999", fontSize: 12 }}>
                              <i className="fas fa-cart-plus"></i> Captura cantidad
                            </span>
                          )}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              );
            })}
            {!cargando && productosFiltrados.length === 0 && (
              <Col md={12}>
                <div style={{ textAlign: "center", padding: 40 }}>
                  <i
                    className="fas fa-box-open"
                    style={{ fontSize: 64, color: "#ccc" }}
                  ></i>
                  <h5 style={{ marginTop: 10 }}>No se encontraron productos</h5>
                  <p style={{ color: "#888" }}>Ajusta el buscador o los filtros</p>
                </div>
              </Col>
            )}
          </Row>

          {/* Paginación */}
          {totalPaginas > 1 && (
            <Row style={{ marginTop: 10 }}>
              <Col md={12} style={{ textAlign: "center" }}>
                <Button
                  size="sm"
                  color="secondary"
                  disabled={pagina === 1}
                  onClick={() => setPagina(pagina - 1)}
                >
                  <i className="fas fa-chevron-left"></i>
                </Button>
                <span style={{ margin: "0 12px" }}>
                  Página {pagina} de {totalPaginas}
                </span>
                <Button
                  size="sm"
                  color="secondary"
                  disabled={pagina === totalPaginas}
                  onClick={() => setPagina(pagina + 1)}
                >
                  <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>
          )}

          {/* RESUMEN STICKY EN PIE DE PAGINA */}
          <div
            style={{
              position: "fixed",
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "#232B41",
              color: "white",
              padding: "10px 20px",
              boxShadow: "0 -2px 10px rgba(0,0,0,0.2)",
              zIndex: 100,
            }}
          >
            <Row noGutters style={{ alignItems: "center" }}>
              <Col md={3}>
                <i className="fas fa-shopping-cart"></i>{" "}
                <b>{cart.length}</b> productos /{" "}
                <b>{totalCantidad}</b> piezas
              </Col>
              <Col md={2}>Subtotal: {moneyUSD(subTotal)}</Col>
              <Col md={2}>IVA: {moneyUSD(iva)}</Col>
              <Col md={2}>
                <b>Total: {moneyUSD(totalGeneral)}</b>
              </Col>
              <Col md={3} style={{ textAlign: "right" }}>
                <Button
                  color="warning"
                  size="sm"
                  href="/PedidosCreate"
                  title="Cambiar a vista clásica"
                >
                  <i className="fas fa-list"></i> Vista clásica
                </Button>{" "}
                <Button
                  color="info"
                  size="sm"
                  onClick={() => setModalCarrito(true)}
                  disabled={cart.length === 0}
                >
                  Ver carrito
                </Button>{" "}
                <Button
                  color="success"
                  size="sm"
                  disabled={!validaBoton || cart.length === 0}
                  onClick={guardarPedido}
                >
                  <i className="fas fa-save"></i> Guardar Pedido
                </Button>{" "}
                <Button color="danger" size="sm" href="/ListadoPedidos">
                  Cancelar
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      ) : undefined}

      {/* MODAL DETALLE */}
      <Modal
        size="md"
        isOpen={modalDetalle}
        toggle={() => setModalDetalle(false)}
      >
        <ModalHeader toggle={() => setModalDetalle(false)}>
          {detalleArt
            ? `${detalleArt.codigo} — ${detalleArt.nombre}`
            : "Detalle"}
        </ModalHeader>
        <ModalBody>
          {detalleArt && (
            <>
              <CarruselFotos
                articulo={detalleArt}
                sinImagen={SIN_IMAGEN}
                cloudBase={URL_FOTO_CLOUDINARY}
                alto={400}
              />
              <Table borderless size="sm" style={{ marginTop: 10 }}>
                <tbody>
                  <tr>
                    <th>Descripción</th>
                    <td>{detalleArt.descripcion || "-"}</td>
                  </tr>
                  <tr>
                    <th>SKU</th>
                    <td>{detalleArt.SKU || "-"}</td>
                  </tr>
                  <tr>
                    <th>EAN</th>
                    <td>{detalleArt.EAN || "-"}</td>
                  </tr>
                  <tr>
                    <th>Marca</th>
                    <td>{detalleArt.marcas?.[0]?.name || "-"}</td>
                  </tr>
                  <tr>
                    <th>Categoría</th>
                    <td>{detalleArt.lineas?.[0]?.name || "-"}</td>
                  </tr>
                  <tr>
                    <th>Piezas por caja</th>
                    <td>{detalleArt.piezasPorCaja || 0}</td>
                  </tr>
                  <tr>
                    <th>Disponible</th>
                    <td>{inventariosDisp[detalleArt._id] || 0}</td>
                  </tr>
                  <tr>
                    <th>Por recibir (embarques)</th>
                    <td>
                      {(() => {
                        const pr = pendRecibirMap[detalleArt._id] || {};
                        const cant = Number(pr.pendiente_recibir || 0);
                        if (cant <= 0) return "-";
                        return `${cant}${
                          pr.proximaLlegada ? ` · llega ${pr.proximaLlegada}` : ""
                        }`;
                      })()}
                    </td>
                  </tr>
                  <tr>
                    <th>Precio (Lista {listaPrecios})</th>
                    <td>{moneyUSD(precioDeArticulo(detalleArt))}</td>
                  </tr>
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalDetalle(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* MODAL CARRITO */}
      <Modal
        size="xl"
        isOpen={modalCarrito}
        toggle={() => setModalCarrito(false)}
      >
        <ModalHeader toggle={() => setModalCarrito(false)}>
          Carrito ({cart.length} productos / {totalCantidad} piezas)
        </ModalHeader>
        <ModalBody>
          <Table striped borderless>
            <thead>
              <tr>
                <th></th>
                <th>Articulo</th>
                <th>Cantidad</th>
                <th>Cajas</th>
                <th>Precio</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cart.map((c) => {
                const art = articulos.find((a) => a._id === c.articulos);
                return (
                  <tr key={c.id}>
                    <td>
                      {art ? (
                        <img
                          src={fotoUrl(art)}
                          alt=""
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "contain",
                            backgroundColor: "#f4f4f4",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = SIN_IMAGEN;
                          }}
                        />
                      ) : null}
                    </td>
                    <td>{c.articulosNombre}</td>
                    <td>
                      <Input
                        type="number"
                        min="0"
                        value={c.cantidad}
                        onChange={(e) =>
                          cambiarCantidadItem(c.id, e.target.value)
                        }
                        style={{ maxWidth: 100 }}
                      />
                    </td>
                    <td>
                      {c.piezasPorCaja > 0
                        ? (Number(c.cantidad) / c.piezasPorCaja).toFixed(2)
                        : "-"}
                    </td>
                    <td>
                      <Input
                        type="number"
                        min="0"
                        step="any"
                        value={c.precio}
                        onChange={(e) =>
                          cambiarPrecioItem(c.id, e.target.value)
                        }
                        style={{ maxWidth: 120 }}
                      />
                    </td>
                    <td>{moneyUSD(c.total)}</td>
                    <td>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => removeItem(c.id)}
                      >
                        <i className="fas fa-times"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
              {cart.length === 0 && (
                <tr>
                  <td colSpan="7" align="center">
                    Carrito vacío
                  </td>
                </tr>
              )}
              <tr>
                <td colSpan="4"></td>
                <td className="negrita" align="right">
                  Subtotal
                </td>
                <td>{moneyUSD(subTotal)}</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="4"></td>
                <td className="negrita" align="right">
                  IVA
                </td>
                <td>{moneyUSD(iva)}</td>
                <td></td>
              </tr>
              <tr>
                <td colSpan="4"></td>
                <td className="negrita" align="right">
                  Total
                </td>
                <td className="negrita">{moneyUSD(totalGeneral)}</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <Row>
            <Col md={6}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Col>
            {/* <Col md={3}>
              <Label>Paquetería</Label>
              <Input
                type="text"
                value={paqueteria}
                onChange={(e) => setPaqueteria(e.target.value)}
              />
            </Col> */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" size="sm" onClick={limpiarCarrito}>
            Vaciar carrito
          </Button>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setModalCarrito(false)}
          >
            Seguir comprando
          </Button>
          <Button
            color="success"
            size="sm"
            disabled={!validaBoton || cart.length === 0}
            onClick={guardarPedido}
          >
            <i className="fas fa-save"></i> Guardar Pedido
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default PedidosCreateMarket;
